<script lang="ts">import { stateUi } from "@infinitro/config";
let { type = "body", titleSize = "h1", titleWeight = "regular", subtitleSize = "large", subtitleWeight = "regular", bodySize = "medium", bodyWeight = "regular", fontFamily = "main", textColor = "white", textAlign = "start", className = "", customStyle = "", centerOnMobile = false, centerOnIpad = false, overflowText = false, overflowTextType = "ellipsis", children } = $props();
const successTextUsesWarmTone = $derived($stateUi.text?.successTextUsesWarmTone ?? false);
const getClass = () => {
	let baseClass = "";
	let weightClass = "";
	if (type === "title") {
		switch (titleSize) {
			case "h1":
				baseClass = "custom-h1";
				break;
			case "h2":
				baseClass = "custom-h2";
				break;
			case "h3":
				baseClass = "custom-h3";
				break;
			case "h4":
				baseClass = "custom-h4";
				break;
			case "h5":
				baseClass = "custom-h5";
				break;
			case "h6":
				baseClass = "custom-h6";
				break;
			default: baseClass = "";
		}
		switch (titleWeight) {
			case "light":
				weightClass = "custom-title-light";
				break;
			case "regular":
				weightClass = "custom-title-regular";
				break;
			case "bold":
				weightClass = "custom-title-bold";
				break;
			case "semibold":
				weightClass = "custom-title-semibold";
				break;
			case "extrabold":
				weightClass = "custom-title-extrabold";
				break;
			case "black":
				weightClass = "custom-title-black";
				break;
			default: break;
		}
		baseClass = `${baseClass} ${weightClass}`;
	} else if (type === "subtitle") {
		let sizeClass = "";
		let weightClass = "";
		switch (subtitleSize) {
			case "large":
				sizeClass = "custom-subtitle-large";
				break;
			case "medium":
				sizeClass = "custom-subtitle-medium";
				break;
			case "small":
				sizeClass = "custom-subtitle-small";
				break;
			default: break;
		}
		switch (subtitleWeight) {
			case "light":
				weightClass = "custom-subtitle-light";
				break;
			case "regular":
				weightClass = "custom-subtitle-regular";
				break;
			case "bold":
				weightClass = "custom-subtitle-bold";
				break;
			case "semibold":
				weightClass = "custom-subtitle-semibold";
				break;
			case "extrabold":
				weightClass = "custom-subtitle-extrabold";
				break;
			default: break;
		}
		baseClass = `${sizeClass} ${weightClass}`;
	} else if (type === "body") {
		let sizeClass = "";
		let weightClass = "";
		switch (bodySize) {
			case "large":
				sizeClass = "custom-body-large";
				break;
			case "medium":
				sizeClass = "custom-body-medium";
				break;
			case "small":
				sizeClass = "custom-body-small";
				break;
			case "xsmall":
				sizeClass = "custom-body-xsmall";
				break;
			case "xxsmall":
				sizeClass = "custom-body-xxsmall";
				break;
			default: break;
		}
		switch (bodyWeight) {
			case "light":
				weightClass = "custom-body-light";
				break;
			case "regular":
				weightClass = "custom-body-regular";
				break;
			case "bold":
				weightClass = "custom-body-bold";
				break;
			case "semibold":
				weightClass = "custom-body-semibold";
				break;
			case "extrabold":
				weightClass = "custom-body-extrabold";
				break;
			case "black":
				weightClass = "custom-body-black";
				break;
			default: break;
		}
		baseClass = `${sizeClass} ${weightClass}`;
	}
	return `${baseClass} ${getAlignmentClass()} ${getOverflowClass()} ${getFontFamilyClass()}`;
};
function getFontFamilyClass() {
	switch (fontFamily) {
		case "main": return "font-main";
		case "alternative": return "font-alternative";
		case "alternative-2": return "font-alternative-2";
		case "alternative-3": return "font-alternative-3";
		default: return "font-main";
	}
}
const getOverflowClass = () => {
	if (overflowText) {
		switch (overflowTextType) {
			case "ellipsis": return "custom-text-ellipsis";
			case "clip": return "custom-text-clip";
			default: return "custom-text-ellipsis";
		}
	}
	return "";
};
const getAlignmentClass = () => {
	switch (textAlign) {
		case "start": return "text-align-start";
		case "center": return "text-align-center";
		case "end": return "text-align-end";
		default: return "";
	}
};
const getElement = () => {
	if (type === "title") {
		return titleSize;
	}
	return "p";
};
const getColorClass = (useWarmSuccess) => {
	switch (textColor) {
		case "white": return "custom-text-white";
		case "gray": return "custom-text-gray";
		case "black": return "custom-text-black";
		case "primary": return "custom-text-primary";
		case "secondary": return "custom-text-secondary";
		case "tertiary": return "custom-text-tertiary";
		case "warning": return "custom-text-warning";
		case "success": return useWarmSuccess ? "custom-text-success-warm" : "custom-text-success";
		case "error": return "custom-text-error";
		case "accent": return "custom-text-accent";
		case "yellow": return "custom-text-yellow";
		default: return "";
	}
};
</script>

<!-- Dynamic Tag Rendering -->
<svelte:element
	this={getElement()}
	class={`${getClass()} ${getColorClass(successTextUsesWarmTone)} ${className} ${centerOnMobile ? 'text-center-mobile' : ''} ${centerOnIpad ? 'text-center-ipad' : ''}`}
	{...{ style: customStyle }}
>
	{@render children?.()}
</svelte:element>

<style>
	.custom-h1 {

		font-size: 56px;

		font-weight: 700;

		line-height: 64px
}

	.custom-h2 {

		font-size: 48px;

		font-weight: 700;

		line-height: 56px
}

	.custom-h3 {

		font-size: 40px;

		font-weight: 700;

		line-height: 48px
}

	.custom-h4 {

		font-size: 32px;

		font-weight: 700;

		line-height: 40px
}

	.custom-h5 {

		font-size: 24px;

		font-weight: 700;

		line-height: 32px
}

	.custom-h6 {

		font-size: 20px;

		font-weight: 700;

		line-height: 28px
}

	.custom-title-light {

		font-weight: 300
}

	.custom-title-regular {

		font-weight: 400
}

	.custom-title-bold {

		font-weight: 700
}

	.custom-title-semibold {

		font-weight: 600
}

	.custom-title-extrabold {

		font-weight: 800
}

	.custom-title-black {

		height: 3rem;

		width: 361px;

		font-size: 40px;

		font-weight: 900;

		font-style: normal;

		line-height: 48px
}

	@media (min-width: 768px) {
		.custom-title-black {

				height: 88px;

				width: 789px;

				font-size: 80px;

				line-height: 88px
		}
	}

	.custom-subtitle-large {

		font-size: 18px;

		font-weight: 600;

		line-height: 24px
}

	.custom-subtitle-medium {

		font-size: 16px;

		font-weight: 600;

		line-height: 24px
}

	.custom-subtitle-small {

		font-size: 14px;

		font-weight: 600;

		line-height: 20px
}

	.custom-subtitle-light {

		font-weight: 300
}

	.custom-subtitle-regular {

		font-weight: 400
}

	.custom-subtitle-bold {

		font-weight: 700
}

	.custom-subtitle-semibold {

		font-weight: 600
}

	.custom-subtitle-extrabold {

		font-weight: 800
}

	.custom-body-large {

		font-size: 16px;

		line-height: 24px
}

	.custom-body-medium {

		font-size: 14px;

		line-height: 20px
}

	.custom-body-small {

		font-size: 12px;

		line-height: 16px
}

	.custom-body-xsmall {

		font-size: 10px;

		line-height: 14px
}

	.custom-body-xxsmall {

		font-size: 8px;

		line-height: 12px
}

	.custom-body-light {

		font-weight: 300
}

	.custom-body-regular {

		font-weight: 400
}

	.custom-body-bold {

		font-weight: 700
}

	.custom-body-semibold {

		font-weight: 600
}

	.custom-body-extrabold {

		font-weight: 800
}

	.custom-body-black {

		font-weight: 900
}

	.custom-text-white {

		--tw-text-opacity: 1;

		color: rgb(255 255 255 / var(--tw-text-opacity, 1))
}

	.custom-text-gray {

		--tw-text-opacity: 1;

		color: rgb(255 255 255 / var(--tw-text-opacity, 1));

		opacity: 0.6
}

	.custom-text-black {

		--tw-text-opacity: 1;

		color: rgb(0 0 0 / var(--tw-text-opacity, 1))
}

	.custom-text-primary {

		color: var(--color-primary-500)
}

	.custom-text-secondary {

		color: var(--color-secondary-500)
}

	.custom-text-tertiary {

		color: var(--color-tertiary-500)
}

	.custom-text-warning {

		color: var(--color-warning-500)
}

	.custom-text-success {

		color: var(--color-success-500)
}

	.custom-text-success-warm {

		color: var(--color-success-500)
}

	.custom-text-error {

		color: var(--color-error-500)
}

	.custom-text-accent {

		color: var(--color-accent-500)
}

	.custom-text-yellow {

		--tw-text-opacity: 1;

		color: rgb(255 206 43 / var(--tw-text-opacity, 1))
}

	.text-align-start {

		text-align: left
}

	.text-align-center {

		text-align: center
}

	.text-align-end {

		text-align: right
}

	.text-center-ipad {

		text-align: center
}

	@media (min-width: 1024px) {
		.text-center-ipad {

				text-align: start
		}
	}

	.text-center-mobile {

		text-align: center
}

	@media (min-width: 768px) {
		.text-center-mobile {

				text-align: start
		}
	}

	.custom-text-ellipsis {

		text-overflow: ellipsis
}

	.custom-text-clip {

		text-overflow: clip
}

	.font-main {

		font-family: var(--font-main)
}
	.font-alternative {

		font-family: var(--font-alternative)
}
	.font-alternative-2 {

		font-family: var(--font-alternative-2)
}
	.font-alternative-3 {

		font-family: var(--font-alternative-3)
}
</style>
